import { TableCell } from "../../table";

export const BaseCellWrapper = ({
  className = "",
  isFirstCell,
  isLastCell,
  placeholder,
  children,
}: {
  className?: string;
  isFirstCell?: boolean;
  isLastCell?: boolean;
  placeholder?: boolean;
  children: React.ReactNode;
}) => {
  const baseClasses = `
    group/Cell relative h-auto max-h-[250px] min-h-[50px] max-w-full
    overflow-y-auto border-r border-b focus:z-[1] min-w-[90px]
    p-0 text-xs ${isFirstCell ? "border-l-0" : ""} ${
      isLastCell ? "border-r-0" : ""
    }
    transition-colors duration-150 ease-in-out
    group-hover:bg-gray-50 group-hover:border-gray-200
  `;

  const placeholderClasses = placeholder
    ? "bg-gray-50 group-hover:border-gray-200 group-hover:bg-gray-100"
    : "bg-white group-hover:bg-gray-50";

  return (
    <TableCell
      className={`${baseClasses} ${placeholderClasses} ${className} shadow-sm`}
    >
      {children}
    </TableCell>
  );
};
